<template>
  <nuxt-layout
    v-if="section === Sections.ChildForYou"
    name="common"
    theme="default"
  >
    <PageChildForYou />
  </nuxt-layout>
</template>

<script lang="ts" setup>
import { Sections } from '~/types/ui';
definePageMeta({
  validate: async (route) => {
    const { section } = route.params;
    return (
      section === Sections.InTheNews ||
      section === Sections.Revisions ||
      section === Sections.ParentForYou ||
      section === Sections.ChildForYou
    );
  },
});

const route = useRoute();

const profile = useProfileStore();

const section = computed(() => route.params.section);

const { redirect } = useRedirect();

switch (section.value) {
  case Sections.ChildForYou:
    if (profile.isParent) {
      await redirect('/');
    }
    if (!profile.isParent && profile.featureFlags.forYou === false) {
      await redirect(`/${Sections.Revisions}`);
    }
    break;
  case Sections.Home:
    await navigateTo('/', {
      replace: true,
    });
    break;
  default: {
    const { contentUserTypeFromRoute } = useContentRouteHelper();

    const { currentContent } = useContentsForUserType(
      contentUserTypeFromRoute.value
    );
    const path =
      currentContent.value && currentContent.value.path
        ? currentContent.value.path
        : '/';

    await navigateTo(path, {
      replace: true,
    });
    break;
  }
}
</script>
